import { Button, Col, Form, Row } from 'antd'
import FormWrapperCreate from 'components/Form/FormWrapperCreate'
import styled from 'styled-components'
import DeliveryForm from './components/DeliveryForm'
import OrderDetailForm from './components/OrderDetailForm'
import ConfirmForm from './components/ConfirmForm'
import { useParams, useHistory } from 'react-router-dom'
import ROUTER from 'services/router'
import { useCallback, useEffect, useState } from 'react'
import { orderService, bankService } from 'services'
import { toast } from 'react-toastify'
import useGetCustomerData from 'state/customer/hooks/useGetCustomerData'
import ModalError from './components/ModalError'
import ModalInfoDeposit from '../profile/components/ModalInfoDeposit'

const WrapperPage = styled.div`
  min-height: 77vh;
  width: 100%;
  padding: 0 20px 40px;

  ${({ theme }) => theme.mediaQueries.sm} {
    .button-add {
      position: absolute;
      right: 20px;
      top: 16px;
    }

    .form-title {
      margin-bottom: 20px;
    }
  }

  @media (max-width: 575px) {
    .ant-form-item .ant-form-item-label {
      padding: 0;
      line-height: 1.5715;
      height: 35px;
    }
  }
`

const ButtonGroups = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`

const Page = ({ dataDetail }: { dataDetail?: any }) => {
  const [form] = Form.useForm()
  const history = useHistory()
  const { id } = useParams()
  const { customerProfile } = useGetCustomerData()

  const [packageSelected, setPackageSelected] = useState<any>()
  const [qty, setQty] = useState<number>(0)
  const [productPriceDefault, setProductPriceDefault] = useState<any | string>(0)
  const [packageList, setPackageList] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [modalError, setModalError] = useState<boolean>(false)
  const [textError, setTextError] = useState<string>('')
  const [openModalDeposit, setOpenModalDeposit] = useState<boolean>(false)
  const [dataConfig, setDataConfig] = useState<any>()
  const [mdt, setMdt] = useState<any>()
  const [dpId, setDpId] = useState(0)
  const [ddId, setDdId] = useState(0)
  const [dwId, setDwId] = useState(0)
  const [spId, setSpId] = useState(0)
  const [sdId, setSdId] = useState(0)
  const [swId, setSwId] = useState(0)

  const handleSubmit = useCallback(() => {

    form.validateFields().then(async (values) => {
      setLoading(true)
      const paramCreate = {
        product_name: values?.orderName,
        view_product: values?.isCheck ? 1 : 0,
        package_ship: values?.typePackage,
        who: values?.transferFee === 0 ? 0 : 1,
        price: values?.orderPrice || 0,
        number_of_package: values?.orderQty,
        product_price: values?.productPrice || 0,
        sendAddress: {
          full_name: values?.delivery_full_name,
          email: values?.delivery_email,
          phone_number: values?.delivery_phone_number,
          address: values?.delivery_address,
          province: values?.delivery_province_id,
          district: values?.delivery_district_id,
          ward: values?.delivery_ward_id,
          note: values?.note,
        },
        receiveAddress: {
          full_name: values?.shipping_full_name,
          email: values?.shipping_email,
          phone_number: values?.shipping_phone_number,
          address: values?.shipping_address,
          province: values?.shipping_province_id,
          district: values?.shipping_district_id,
          ward: values?.shipping_ward_id,
        },
      }
      orderService.create(
        paramCreate,
        (response) => {
          history.push(ROUTER.orderTracking)
          setLoading(false)
        },
        (response) => {
          setLoading(false)
          if (response?.screen === 'modal') {
            setTextError(response?.message)
            setModalError(true)
          } else {
            toast.error(response?.message, { autoClose: false })
          }
        }
      )
    })
  }, [form, history])
  const handleOnCancelError = () => {
    setModalError(false);
    if(textError.indexOf('nạp quỹ') > 0){
      setOpenModalDeposit(true);
      if(typeof dataConfig === 'undefined'){
        bankService.getConfigDeposit((data) => setDataConfig(data))
      }
    }
  }
  const handleCbUserInfo = (data,tpe) => {
    if(tpe === 'delivery'){
      form.setFieldsValue({
        delivery_full_name: data?.name,
        delivery_phone_number: data?.phone,
        delivery_address: data?.address?.detail,
        delivery_province_id: data?.address?.province?.id,
        delivery_district_id: data?.address?.district?.id,
        delivery_ward_id: data?.address?.ward?.id,
        note: data?.note
      });
      setDpId(data?.address?.province?.id)
      setDdId(data?.address?.district?.id)
      setDwId(data?.address?.ward?.id)
    }else{
      form.setFieldsValue({
        shipping_full_name: data?.name,
        shipping_phone_number: data?.phone,
        shipping_address: data?.address?.detail,
        shipping_province_id: data?.address?.province?.id,
        shipping_district_id: data?.address?.district?.id,
        shipping_ward_id: data?.address?.ward?.id
      });
      setSpId(data?.address?.province?.id)
      setSdId(data?.address?.district?.id)
      setSwId(data?.address?.ward?.id)
    }
  }
  useEffect(() => {
    if (id) {
      orderService.getDetail(id, (data) => {
        setMdt(data?.data);
      })
    }
  }, [])

  useEffect(() => {
    if (dataDetail || mdt) {
      if(dataDetail){
        form.setFieldsValue({
          orderName: dataDetail?.detail?.title,
          isCheck: dataDetail?.detail?.view_product,
          typePackage: dataDetail?.detail?.package?.id,
          transferFee: dataDetail?.detail?.who,
          orderPrice: dataDetail?.detail?.price,
          orderQty: dataDetail?.detail?.number_of_package,
          productPrice: dataDetail?.product_price,
          note: dataDetail?.sender?.note,
          delivery_full_name: dataDetail?.sender?.full_name,
          delivery_email: dataDetail?.sender?.email,
          delivery_phone_number: dataDetail?.sender?.phone_number,
          delivery_address: dataDetail?.sender?.address,
          delivery_province_id: dataDetail?.sender?.province?.id,
          delivery_district_id: dataDetail?.sender?.district?.id,
          delivery_ward_id: dataDetail?.sender?.ward?.id,
          shipping_full_name: dataDetail?.receiver?.full_name,
          shipping_email: dataDetail?.receiver?.email,
          shipping_phone_number: dataDetail?.receiver?.phone_number,
          shipping_address: dataDetail?.receiver?.address,
          shipping_province_id: dataDetail?.receiver?.province?.id,
          shipping_district_id: dataDetail?.receiver?.district?.id,
          shipping_ward_id: dataDetail?.receiver?.ward?.id,
          isConfirm: dataDetail?.product_price ?? false,
        })
        setQty(dataDetail?.detail?.number_of_package)
      }else{
        form.setFieldsValue({
          delivery_full_name: mdt?.sender?.full_name,
          delivery_phone_number: mdt?.sender?.phone_number,
          delivery_email: mdt?.sender?.email,
          delivery_province_id: mdt?.sender?.province?.id,
          delivery_district_id: mdt?.sender?.district?.id,
          delivery_ward_id: mdt?.sender?.ward?.id,
          delivery_address: mdt?.sender?.address,
          note: mdt?.sender?.note,
          //
          shipping_full_name: mdt?.receiver?.full_name,
          shipping_phone_number: mdt?.receiver?.phone_number,
          shipping_email: mdt?.receiver?.email,
          shipping_province_id: mdt?.receiver?.province?.id,
          shipping_district_id: mdt?.receiver?.district?.id,
          shipping_ward_id: mdt?.receiver?.ward?.id,
          shipping_address: mdt?.receiver?.address,
          //
          orderName: mdt?.detail?.title,
          isCheck: mdt?.detail?.view_product,
          transferFee: mdt?.detail?.who,
          orderPrice: mdt?.detail?.price,
        })
        setProductPriceDefault(mdt?.product_price);
      }
    } else {      
      form.setFieldValue('orderPrice', 0)
      form.setFieldValue('productPrice', 12)
      form.setFieldValue('orderQty', 1)
      form.setFieldValue('isCheck', 0)
      setQty(1)

      form.setFieldsValue({
        delivery_full_name: customerProfile?.full_name,
        delivery_email: customerProfile?.email,
        delivery_phone_number: customerProfile?.phone_number,
      })
    }
  }, [customerProfile, dataDetail, mdt, form])

  return (
    <>
      <WrapperPage>
        <p className='title-page'>Tạo đơn vận chuyển</p>
        <Row gutter={[14, 14]}>
          <Col span={24}>
            <fieldset disabled={!!dataDetail}>
              <Row gutter={[14, 14]}>
                <Col span={24}>
                  <Row gutter={[14, 14]}>
                    <Col span={24}>
                      <FormWrapperCreate title='Thông tin người gửi hàng'>
                        <DeliveryForm
                          provinceId={mdt ? mdt?.sender?.province?.id : dpId}
                          districtId={mdt ? mdt?.sender?.district?.id : ddId}
                          wardId={mdt ? mdt?.sender?.ward?.id : dwId}
                          formType='delivery'
                          form={form}
                          dataDetail={dataDetail}
                          cbUserInfo={handleCbUserInfo}
                        />
                      </FormWrapperCreate>
                    </Col>

                    <Col span={24}>
                      <FormWrapperCreate title='Thông tin người nhận hàng'>
                        <DeliveryForm
                          provinceId={mdt ? mdt?.receiver?.province?.id : spId}
                          districtId={mdt ? mdt?.receiver?.district?.id : sdId}
                          wardId={mdt ? mdt?.receiver?.ward?.id : swId}
                          formType='shipping'
                          form={form}
                          dataDetail={dataDetail}
                          cbUserInfo={handleCbUserInfo} />
                      </FormWrapperCreate>
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <Row gutter={[14, 14]}>
                    <Col span={24}>
                      <FormWrapperCreate title='Chi tiết kiện hàng'>
                        <OrderDetailForm
                          form={form}
                          setPackageSelected={setPackageSelected}
                          packageSelected={packageSelected}
                          setQty={setQty}
                          customerProfile={customerProfile}
                          packageList={packageList}
                          setPackageList={setPackageList}
                          setProductPriceDefault={setProductPriceDefault}
                          orderPriceDefault={mdt ? mdt?.detail?.price : 0}
                          transporterId={mdt ? mdt?.detail?.package?.transporter_id : 0}
                          usedPackage={mdt ? mdt?.detail?.package : null}
                          dataDetail={dataDetail}
                        />
                      </FormWrapperCreate>
                    </Col>

                    <Col span={24}>
                      {packageSelected && (
                        <FormWrapperCreate title='Bảo đảm hàng hóa'>
                          <ConfirmForm productPriceDefault={productPriceDefault} form={form} packageSelected={packageSelected} qty={qty} dataDetail={dataDetail} />
                        </FormWrapperCreate>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </fieldset>
          </Col>

          <Col span={24}>
            <ButtonGroups>
              <Button type='primary' size='large' onClick={handleSubmit} loading={loading}>
                Tạo đơn hàng
              </Button>
              <Button size='large' onClick={() => history.push(ROUTER.adminHome)}>
                Về trang chủ
              </Button>
            </ButtonGroups>
          </Col>
        </Row>
      </WrapperPage>
      <ModalInfoDeposit
        open={openModalDeposit}
        onCancel={() => setOpenModalDeposit(false)}
        dataConfig={dataConfig}
        profile={customerProfile}
      />
      <ModalError open={modalError} onCancel={handleOnCancelError} text={textError} />
    </>
  )
}

export default Page
